/* eslint-disable react/no-unused-prop-types */
import { t } from '@lingui/macro';
import { arrayOf, shape, string } from 'prop-types';
import { ENTITY_TYPES } from '../../../services/EntityService';
import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropDefaults, filterPropTypes } from '../../page-framework/filter/FilterPropTypes';

import EntityTagGroupFilter from '../entity-tag-group-filter/EntityTagGroupFilter';
import getEntityTagGroupFilterServiceFactory from '../entity-tag-group-filter/EntityTagGroupFilterServiceFactory';

export const filterId = 'SitesGroup';

export const filterTitle = t`Sites`;

function SiteGroupFilter(props) {
    const { state, filterActions } = props;

    return <EntityTagGroupFilter state={state} filterActions={filterActions} entityType={ENTITY_TYPES.SITE} />;
}

SiteGroupFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        tags: arrayOf(string),
        tagOp: string,
        sites: arrayOf(string),
    }),
};

SiteGroupFilter.defaultProps = {
    ...filterPropDefaults,

    id: filterId,
    title: filterTitle,
    state: undefined,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityTagGroupFilterServiceFactory(ENTITY_TYPES.SITE),
})(SiteGroupFilter);
